import React from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Outbox from './../../components/patchCenter/outbox';

const patchcenter = () => {
  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <Outbox />
    </div>
  );
};

export default patchcenter;
